<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <ol :class="cn('flex flex-wrap items-center gap-1.5 text-sm wrap-break-word text-slate-500 sm:gap-2.5', props.class)">
    <slot />
  </ol>
</template>
